import {Component} from '@angular/core';

@Component({
  selector: 'app-cross-arrows-icon',
  templateUrl: './cross-arrows-icon.component.html'
})
export class CrossArrowsIconComponent {
}
